'use client';

import { c as _c } from "react/compiler-runtime";
import { getBudgetsByCodePath, getCodePathFromParams } from '@/modules/finances/lib/utils';
import { ATLAS_BUDGETS, BUDGETS } from '../../../mocks';
import { ExpensesMetricChart } from '../expenses-metric-chart/expenses-metric-chart';
import { ExpensesMetricLegend } from '../expenses-metric-legend';
import { useExpensesMetricChart } from '../use-expenses-metric-chart';
import type { ExpensesMetricBudgetAnalytic } from '../../../types';
interface ExpensesMetricChartContentProps {
  params?: string[];
  budgetsAnalytics: ExpensesMetricBudgetAnalytic;
  year: string;
}
function ExpensesMetricChartContent(t0) {
  const $ = _c(27);
  const {
    params,
    budgetsAnalytics,
    year
  } = t0;
  let codePath;
  let t1;
  if ($[0] !== params) {
    codePath = getCodePathFromParams(params);
    t1 = getBudgetsByCodePath(codePath, BUDGETS);
    $[0] = params;
    $[1] = codePath;
    $[2] = t1;
  } else {
    codePath = $[1];
    t1 = $[2];
  }
  const budgets = t1;
  let t2;
  if ($[3] !== budgets || $[4] !== budgetsAnalytics || $[5] !== codePath) {
    t2 = {
      budgetsAnalytics,
      budgets,
      allBudgets: ATLAS_BUDGETS,
      codePath
    };
    $[3] = budgets;
    $[4] = budgetsAnalytics;
    $[5] = codePath;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    series,
    showScrollAndToggle,
    handleToggleSeries,
    handleChangeSwitch,
    isChecked,
    refExpensesMetricChart,
    onLegendItemHover,
    onLegendItemLeave,
    showLegendValue,
    selectedGranularity,
    isCumulative,
    cumulativeType
  } = useExpensesMetricChart(t2);
  let t3;
  if ($[7] !== cumulativeType || $[8] !== isCumulative || $[9] !== refExpensesMetricChart || $[10] !== selectedGranularity || $[11] !== series || $[12] !== year) {
    t3 = <div className="flex min-w-0 flex-1"><ExpensesMetricChart refExpensesMetricChart={refExpensesMetricChart} year={year} selectedGranularity={selectedGranularity} series={series} isCumulative={isCumulative} cumulativeType={cumulativeType} /></div>;
    $[7] = cumulativeType;
    $[8] = isCumulative;
    $[9] = refExpensesMetricChart;
    $[10] = selectedGranularity;
    $[11] = series;
    $[12] = year;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== handleChangeSwitch || $[15] !== handleToggleSeries || $[16] !== isChecked || $[17] !== isCumulative || $[18] !== onLegendItemHover || $[19] !== onLegendItemLeave || $[20] !== series || $[21] !== showLegendValue || $[22] !== showScrollAndToggle) {
    t4 = <div className="flex w-full md:w-65.75 lg:w-90.5 xl:w-88.75 2xl:w-98"><ExpensesMetricLegend series={series} handleToggleSeries={handleToggleSeries} onLegendItemHover={onLegendItemHover} onLegendItemLeave={onLegendItemLeave} showLegendValue={showLegendValue} showScrollAndToggle={showScrollAndToggle} isChecked={isChecked} handleChangeSwitch={handleChangeSwitch} isCumulative={isCumulative} /></div>;
    $[14] = handleChangeSwitch;
    $[15] = handleToggleSeries;
    $[16] = isChecked;
    $[17] = isCumulative;
    $[18] = onLegendItemHover;
    $[19] = onLegendItemLeave;
    $[20] = series;
    $[21] = showLegendValue;
    $[22] = showScrollAndToggle;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== t3 || $[25] !== t4) {
    t5 = <div className="flex w-full flex-col gap-4 sm:gap-6 md:flex-row 2xl:gap-8">{t3}{t4}</div>;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
}
export { ExpensesMetricChartContent };